import axios from "axios";
import { CONST } from "../config/const";

// 商材 - トスアップパートナー一覧取得（逆引き）
export async function getProductTossUpSaleCompanys(id: string) {
  try {
    const path = "productTossUpSaleCompanys";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [], saleCompanyDatas: [] };
    }
    return {
      sudDatas: response.data.fetch_data,
      saleCompanyDatas: response.data.sale_company_data,
    };
  } catch (error) {
    return { sudDatas: [], saleCompanyDatas: [] };
  }
}

// 商材 - トスアップパートナー登録
export async function postProductTossUpSaleCompany(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "productTossUpSaleCompanys";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl2 + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {}
}
